import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "black",
        d: "M0 0h60v20H0z"
      }),
      _createElementVNode("path", {
        fill: "red",
        d: "M0 20h60v20H0z"
      }),
      _createElementVNode("path", {
        fill: "#FFCF00",
        d: "M0 40h60v20H0z"
      })
    ], -1)
  ])))
}
export default { render: render }